import { native, pageVisibleOnce } from '@forest/native-services'
import { wait } from '@forest/shared'
import { createSignal, onCleanup, onMount, Show } from 'solid-js'

export function CloseButton() {
  const [isActive, setIsActive] = createSignal(false)
  const [isHidden, setIsHidden] = createSignal(false)

  onMount(() => {
    pageVisibleOnce.promise.then(() => {
      // wait for a macro task to prevent immediate activation, which causes the button having no transition
      wait(0).then(() => {
        setIsActive(true)
      })
      native.general.logEvent({
        event_name: 'component_show',
        event_params: {
          component_name: 'new_user_paywall_delay_close_btn',
        },
      })
    })

    const hideHandler = () => setIsHidden(true)
    const showHandler = () => setIsHidden(false)
    window.addEventListener('hide-close-button', hideHandler)
    window.addEventListener('show-close-button', showHandler)

    onCleanup(() => {
      window.removeEventListener('hide-close-button', hideHandler)
      window.removeEventListener('show-close-button', showHandler)
    })
  })

  return (
    <Show when={!isHidden()}>
      <button
        class="close-btn fixed right-4 top-[calc(4px+var(--safe-area-top))] z-[40] flex items-center justify-center overflow-clip rounded-full backdrop-blur-[37.5px] transition-transform delay-3000"
        classList={{
          'translate-y-0': isActive(),
          'translate-y-[calc(-100%-4px-var(--safe-area-top))]': !isActive(),
        }}
        style="will-change: backdrop-filter;"
        onClick={() => native.general.close()}
      >
        <svg
          width="37"
          height="36"
          viewBox="0 0 37 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <rect
              x="0.75"
              y="0.75"
              width="35.5"
              height="34.5"
              rx="17.25"
              fill="white"
              fill-opacity="0.7"
            />
            <rect
              x="0.75"
              y="0.75"
              width="35.5"
              height="34.5"
              rx="17.25"
              stroke="url(#paint0_linear_350_2820)"
              stroke-width="1.5"
            />
            <path
              d="M14.2144 13.7144L22.7857 22.2858"
              stroke="#333333"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.2143 22.2858L22.7856 13.7144"
              stroke="#333333"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_350_2820"
              x1="19.811"
              y1="-6.75551e-07"
              x2="29.7414"
              y2="33.0129"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" stop-opacity="0.3" />
              <stop offset="1" stop-color="white" stop-opacity="0.1" />
            </linearGradient>
          </defs>
        </svg>
      </button>
    </Show>
  )
}
